import React, { Component } from 'react';
import { MARKETING_MODAL, PAYROLL_MODAL } from '../../redux/reducers/modal';
import MarketingStatsModal from '../blocks/marketing/MarketingStatsModal';
import ReduxModal from '../blocks/modal/ReduxModal';
import MainNav from '../blocks/navigation/MainNav';
import NotificationsContent from '../blocks/notifications/NotificationsContent';
import PayrollGeneratorModal from '../blocks/payroll/PayrollGeneratorModal';
import type {
  NotificationState, Project, Router, User,
} from '../../types';

type State = any;

type Props = {
  notifications: NotificationState,
  getNotifications: (page?: number) => Promise<any>,
  addNotification: (target: string, content: string, sendTo: any) => Promise<any>,
  checkForNotifications: () => void,
  onOpenModal: (payload: any) => void,
  onCloseModal: (payload: any) => void,
  onUpdateModal: (payload: any) => void,
  projects: Array<Project>,
  clearNotifications: () => void,
  currentUser: User,
  router: Router,
};

class Notifications extends Component<Props, State> {
  handlePayrollGeneratorClick = () => {
    const { onOpenModal } = this.props;
    onOpenModal({ id: PAYROLL_MODAL });
  };

  handlePayrollModalClose = () => {
    const { onCloseModal } = this.props;
    onCloseModal({ id: PAYROLL_MODAL });
  };

  handleMarketingStatsClick = () => {
    const { onOpenModal } = this.props;
    onOpenModal({ id: MARKETING_MODAL });
  };

  handleMarketingModalClose = () => {
    const { onCloseModal } = this.props;
    onCloseModal({ id: MARKETING_MODAL });
  };

  render(): React.ReactNode {
    const { currentUser, router } = this.props;

    return (
      <div className="notifications-view container-view view-wrapper">
        <MainNav
          currentUser={currentUser}
          navigate={router.navigate}
          onPayrollGeneratorClick={this.handlePayrollGeneratorClick}
          onMarketingStatsClick={this.handleMarketingStatsClick}
        />
        <NotificationsContent
          {...this.props}
        />
        <ReduxModal id={PAYROLL_MODAL}>
          <PayrollGeneratorModal
            onCloseModal={this.handlePayrollModalClose}
          />
        </ReduxModal>
        <ReduxModal id={MARKETING_MODAL}>
          <MarketingStatsModal
            onCloseModal={this.handleMarketingModalClose}
          />
        </ReduxModal>
      </div>
    );
  }
}

export default Notifications;
